import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

// Utility to generate unique IDs (simple timestamp-based for this example)
// const generateUniqueId = () =>
//   `tab-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;

const SwitchTab = ({
  tabs,
  defaultActiveIndex = 0,
  containerClass = "",
  navClass = "",
  navItemClass = "",
  navLinkClass = "nav-link w-100",
  tabContentClass = "",

  ontabClick = (tabtype: any) => { },
}) => {
  const [activeTab, setActiveTab] = useState(defaultActiveIndex);
  const navIdRef = useRef(
    `tabnav-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`
  );
  const tabContentIdRef = useRef(
    `tabcontent-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`
  );
  const navId = navIdRef.current;
  const tabContentId = tabContentIdRef.current;

  const isActivePath = (tabPath, currentPath) => {
    // return (
    //   currentPath === tabPath ||
    //   currentPath === currentPath.startsWith("/buy/") ||
    //   currentPath === currentPath.startsWith("/sell/") ||
    //   currentPath === tabPath + "/" ||
    //   currentPath.startsWith(tabPath + "/")
    // );
    // console.log("currentPath", currentPath);
    // console.log("tabPath", tabPath);
    if (currentPath === tabPath || currentPath === tabPath + "/") {
      return true;
    }
    if (currentPath.startsWith(tabPath + "/")) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    const fallbackIndex = defaultActiveIndex || 0;
    let index = tabs.findIndex((tab) =>
      isActivePath(tab.path, location.pathname)
    );

    if (index === -1) {
      const homeTabIndex = tabs.findIndex((tab) => tab.path === "/homepage");
      index = homeTabIndex !== -1 ? homeTabIndex : fallbackIndex;
    }

    setActiveTab(index);
  }, [location.pathname, tabs, defaultActiveIndex]);

  const handleTabClick = (e) => {
    setActiveTab(defaultActiveIndex);
    {
      ontabClick && ontabClick(e?.tabtype);
    }
  };

  return (
    <div className={`tab-container ${containerClass}`}>
      {/* Tab Navigation */}
      <ul className={`${navClass} nav nav-pills`} id={navId} role="tablist">
        {tabs.map((tab, index) =>
          tab.path && tab.path.startsWith("https") ? (
            <li
              className={`${navItemClass} nav-item`}
              key={index}
              role="presentation"
            >
              <a
                href={tab.path}
                target="_blank"
                rel="noopener noreferrer" // Security for external links
                className={`${navLinkClass}`}
              >
                {tab.title}
              </a>
            </li>
          ) : (
            <li
              className={`${navItemClass} nav-item `}
              key={index}
              role="presentation"
            >
              <button
                className={`${navLinkClass} ${activeTab === index ? "active" : ""
                  }`}
                id={`${navId}-${index}`} // Unique ID for each tab
                data-bs-toggle="pill"
                data-bs-target={`#${tabContentId}-${index}`} // Unique target ID
                type="button"
                role="tab"
                aria-controls={`${tabContentId}-${index}`}
                aria-selected={activeTab === index}
                onClick={() => handleTabClick(tab)}
              >
                {tab.path ? (
                  <Link to={tab.path}>
                    <i className={tab.fontIcon}></i>
                    {tab.title}
                  </Link>
                ) : (
                  <a>
                    <i className={tab.fontIcon}></i>
                    {tab.title}
                  </a>
                )}
                {/* <Link to={tab?.path}>
                  <i className={tab.fontIcon}></i>
                  {tab.title}
                </Link> */}
              </button>
            </li>
          )
        )}
      </ul>
      {/* Tab Content */}
      <div className={`tab-content ${tabContentClass}`} id={tabContentId}>
        {tabs.map((tab, index) => (
          <div
            key={index}
            className={`tab-pane fade ${activeTab === index ? "show active" : ""
              }`}
            id={`${tabContentId}-${index}`} // Unique ID for each tab pane
            role="tabpanel"
            aria-labelledby={`${navId}-${index}`}
            tabIndex={0}
          >
            {tab.content}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SwitchTab;
